import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { getStorage } from '@/utils';

import en from './en.json'
import zh from './zh-Hans.json'
import sw from './sw.json'

Vue.use(VueI18n)

let deviceInfo = JSON.parse(getStorage("device-info") || "{}");
console.log("deviceInfo", deviceInfo.countryNumCode);
const i18n = new VueI18n({
    locale: deviceInfo.countryNumCode && deviceInfo.countryNumCode == '255' ?'sw' : 'en', // 获取已设置的语言，如果没有默认繁体
    messages: {
        en,
        sw
    }
})

export default i18n